import { NgClass } from '@angular/common';
import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { LokaliseTranslatePipe } from 'src/app/lokalise';

@Component({
  selector: 'app-card-nav-item',
  templateUrl: './card-nav-item.component.html',
  styleUrls: ['./card-nav-item.component.scss'],
  imports: [RouterLinkActive, RouterLink, NgClass, LokaliseTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardNavItemComponent {
  readonly url = input<string>(undefined);
  readonly fragment = input('');
  readonly title = input<string>(undefined);
  readonly icon = input<string>(undefined);
  readonly isNew = input(false);
  readonly isNewAnalyses = input(false);

  readonly clicked = output();
}
